module.exports = __webpack_public_path__ + "img/5.5aa20f4f.png";